// import React, { useState } from "react";
// import { db } from "../firebase";
// import { ref as dbRef, push } from "firebase/database";
// import { motion, AnimatePresence } from "framer-motion";
// import AdminNavbar from "../components/Navbar";
// import emailjs from "@emailjs/browser";

// const DealerPortal = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [dealerData, setDealerData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     company: "",
//     city: "",
//     experience: "",
//     message: "",
//   });
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setDealerData({ ...dealerData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       // 1. Save to Firebase
//       await push(dbRef(db, "dealerApplications"), dealerData);

//       // 2. Send email via EmailJS
//       await emailjs.send(
//         "service_49p1r9m",
//         "template_m2q8dia",
//         {
//           applicant_name: dealerData.name,
//           applicant_email: dealerData.email,
//           applicant_phone: dealerData.phone,
//           applicant_company: dealerData.company || "N/A",
//           applicant_city: dealerData.city || "N/A",
//           applicant_experience: dealerData.experience || "N/A",
//           applicant_message: dealerData.message || "No additional message.",
//         },
//         "VqVfmOu1crdB8Fa-i"
//       );

//       alert("Your application has been submitted successfully! Our team will contact you soon.");
//       setDealerData({
//         name: "",
//         email: "",
//         phone: "",
//         company: "",
//         city: "",
//         experience: "",
//         message: "",
//       });
//       setShowModal(false);
//     } catch (error) {
//       console.error("Error submitting application:", error);
//       alert("Something went wrong, please try again!");
//     }
//     setLoading(false);
//   };

//   return (
//     <>
//       <AdminNavbar />

//       <div className="min-h-screen bg-gray-100 p-6 mt-20">
//         <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl p-8">
//           <h2 className="text-2xl font-bold text-gray-800 mb-4">
//             Become an Authorized HLC Dealer
//           </h2>
//           <p className="text-gray-600 mb-6 leading-relaxed">
//             Partner with HLC and bring high-quality lighting products to your
//             customers. We value long-term relationships and provide full
//             marketing, training, and logistical support to our dealers across
//             Pakistan.
//           </p>

//           <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-2">
//             Requirements:
//           </h3>
//           <ul className="list-disc list-inside text-gray-600 space-y-1 mb-6">
//             <li>Valid business registration or trade license</li>
//             <li>Physical retail or distribution outlet</li>
//             <li>Experience in electrical or lighting products preferred</li>
//             <li>Commitment to maintaining brand quality and service standards</li>
//           </ul>

//           <h3 className="text-xl font-semibold text-gray-800 mb-2">
//             Procedure:
//           </h3>
//           <ol className="list-decimal list-inside text-gray-600 space-y-1 mb-6">
//             <li>Fill out the dealer application form below</li>
//             <li>Our representative will contact you within 3–5 business days</li>
//             <li>Submit required business documents</li>
//             <li>Attend orientation and finalize agreement</li>
//           </ol>

//           <motion.button
//             whileHover={{ scale: 1.05 }}
//             onClick={() => setShowModal(true)}
//             className="bg-gradient-to-r from-[#542757] to-[#9b1f6c] text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:opacity-90 transition"
//           >
//             Become a Dealer
//           </motion.button>
//         </div>
//       </div>

//       {/* Modal Form */}
//       <AnimatePresence>
//         {showModal && (
//           <motion.div
//             className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             <motion.div
//               className="bg-white rounded-2xl p-6 w-full max-w-lg shadow-xl relative"
//               initial={{ scale: 0.8 }}
//               animate={{ scale: 1 }}
//               exit={{ scale: 0.8 }}
//             >
//               <h2 className="text-2xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-[#542757] to-[#9b1f6c] mb-4">
//                 Dealer Application Form
//               </h2>

//               <form onSubmit={handleSubmit} className="space-y-3">
//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Full Name"
//                   value={dealerData.name}
//                   onChange={handleChange}
//                   required
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email Address"
//                   value={dealerData.email}
//                   onChange={handleChange}
//                   required
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <input
//                   type="text"
//                   name="phone"
//                   placeholder="Phone Number"
//                   value={dealerData.phone}
//                   onChange={handleChange}
//                   required
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <input
//                   type="text"
//                   name="company"
//                   placeholder="Company Name"
//                   value={dealerData.company}
//                   onChange={handleChange}
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <input
//                   type="text"
//                   name="city"
//                   placeholder="City"
//                   value={dealerData.city}
//                   onChange={handleChange}
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <input
//                   type="text"
//                   name="experience"
//                   placeholder="Business Experience (in years)"
//                   value={dealerData.experience}
//                   onChange={handleChange}
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <textarea
//                   name="message"
//                   placeholder="Additional Message"
//                   value={dealerData.message}
//                   onChange={handleChange}
//                   rows="3"
//                   className="w-full border p-3 rounded-lg focus:ring-2 focus:ring-purple-500"
//                 />
//                 <div className="flex justify-end space-x-3">
//                   <button
//                     type="button"
//                     onClick={() => setShowModal(false)}
//                     className="px-5 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 transition"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className="px-5 py-2 rounded-lg bg-gradient-to-r from-[#542757] to-[#9b1f6c] text-white font-semibold hover:opacity-90 transition"
//                   >
//                     {loading ? "Submitting..." : "Submit"}
//                   </button>
//                 </div>
//               </form>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// };

// export default DealerPortal;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AdminNavbar from "../components/Navbar";
import emailjs from "@emailjs/browser";
import HlcFooter from "../components/HlcFooter";
import { API_BASE_URL } from "../config/apiConfig";

const DealerPortal = () => {
  const [showModal, setShowModal] = useState(false);
  const [dealerData, setDealerData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    city: "",
    experience: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setDealerData({ ...dealerData, [e.target.name]: e.target.value });
  };

  // ROLLBACK: original Firebase implementation:
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     await push(dbRef(db, "dealerApplications"), dealerData);
  //     await emailjs.send(
  //       "service_49p1r9m",
  //       "template_m2q8dia",
  //       {
  //         applicant_name: dealerData.name,
  //         applicant_email: dealerData.email,
  //         applicant_phone: dealerData.phone,
  //         applicant_company: dealerData.company || "N/A",
  //         applicant_city: dealerData.city || "N/A",
  //         applicant_experience: dealerData.experience || "N/A",
  //         applicant_message: dealerData.message || "No additional message.",
  //       },
  //       "VqVfmOu1crdB8Fa-i"
  //     );
  //     alert("Your application has been submitted successfully!");
  //     setDealerData({ name: "", email: "", phone: "", company: "", city: "", experience: "", message: "" });
  //     setShowModal(false);
  //   } catch (error) {
  //     console.error(error);
  //     alert("Something went wrong!");
  //   }
  //   setLoading(false);
  // };
  // Submit to adminhlc-api (MySQL) — Step 7 of the Firebase->PHP migration.
  // EmailJS side effect kept exactly as-is (unrelated third-party call).
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/public/dealers/create.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(dealerData),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || "Failed to submit application");
      }

      await emailjs.send(
        "service_49p1r9m",
        "template_m2q8dia",
        {
          applicant_name: dealerData.name,
          applicant_email: dealerData.email,
          applicant_phone: dealerData.phone,
          applicant_company: dealerData.company || "N/A",
          applicant_city: dealerData.city || "N/A",
          applicant_experience: dealerData.experience || "N/A",
          applicant_message: dealerData.message || "No additional message.",
        },
        "VqVfmOu1crdB8Fa-i"
      );

      alert("Your application has been submitted successfully!");
      setDealerData({
        name: "",
        email: "",
        phone: "",
        company: "",
        city: "",
        experience: "",
        message: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error(error);
      alert("Something went wrong!");
    }
    setLoading(false);
  };

  return (
    <>
      <AdminNavbar />

      <div className="min-h-screen bg-gray-100 px-4 py-6 mt-14">
        <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-2xl p-6 md:p-8">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
            Become an Authorized HLC Dealer
          </h2>

          <p className="text-sm md:text-base text-gray-600 mb-6 leading-relaxed">
            Partner with HLC and bring high-quality lighting products to your
            customers. We provide marketing, training, and full support across Pakistan.
          </p>

          {/* Requirements + Procedure in 2 columns on mobile */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Requirements:
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                <li>Valid business registration</li>
                <li>Retail or distribution outlet</li>
                <li>Lighting experience preferred</li>
                <li>Maintain brand quality</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Procedure:
              </h3>
              <ol className="list-decimal list-inside text-sm text-gray-600 space-y-1">
                <li>Fill application form</li>
                <li>Contact within 3–5 days</li>
                <li>Submit documents</li>
                <li>Finalize agreement</li>
              </ol>
            </div>
          </div>

          <div className="mt-6">
            <motion.button
              whileHover={{ scale: 1.05 }}
              onClick={() => setShowModal(true)}
              className="w-full md:w-auto bg-gradient-to-r from-[#542757] to-[#9b1f6c] text-white px-6 py-3 rounded-lg font-semibold shadow-md hover:opacity-90 transition"
            >
              Become a Dealer
            </motion.button>
          </div>
        </div>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 px-3"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-white rounded-2xl w-full max-w-lg shadow-xl p-5 relative max-h-[90vh] overflow-y-auto"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
            >
              <h2 className="text-xl font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-[#542757] to-[#9b1f6c] mb-4">
                Dealer Application
              </h2>

              <form onSubmit={handleSubmit} className="space-y-3">
                {/* GRID FORM */}
                <div className="grid grid-cols-2 gap-3">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={dealerData.name}
                    onChange={handleChange}
                    required
                    className="col-span-2 border p-2.5 rounded-lg text-sm"
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={dealerData.email}
                    onChange={handleChange}
                    required
                    className="col-span-2 border p-2.5 rounded-lg text-sm"
                  />

                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone"
                    value={dealerData.phone}
                    onChange={handleChange}
                    required
                    className="border p-2.5 rounded-lg text-sm"
                  />

                  <input
                    type="text"
                    name="city"
                    placeholder="City"
                    value={dealerData.city}
                    onChange={handleChange}
                    className="border p-2.5 rounded-lg text-sm"
                  />

                  <input
                    type="text"
                    name="company"
                    placeholder="Company"
                    value={dealerData.company}
                    onChange={handleChange}
                    className="border p-2.5 rounded-lg text-sm"
                  />

                  <input
                    type="text"
                    name="experience"
                    placeholder="Experience"
                    value={dealerData.experience}
                    onChange={handleChange}
                    className="border p-2.5 rounded-lg text-sm"
                  />
                </div>

                <textarea
                  name="message"
                  placeholder="Additional Message"
                  value={dealerData.message}
                  onChange={handleChange}
                  rows="3"
                  className="w-full border p-2.5 rounded-lg text-sm"
                />

                {/* Buttons */}
                <div className="flex justify-between gap-3 pt-2">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="w-1/2 py-2 rounded-lg bg-gray-200 text-sm"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-1/2 py-2 rounded-lg bg-gradient-to-r from-[#542757] to-[#9b1f6c] text-white text-sm"
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <HlcFooter/>
    </>
  );
};

export default DealerPortal;